import { Severity } from '../../../../../../types';
import { GatewayDAO } from '../../../../../../data/SystemManagementDAO';
import { v4 } from 'uuid';
const debug = process.env.REACT_APP_DEBUG && false;
export const handleDeleteGateway = async (gateway, userFunctions, contextCustomer, contextUser) => {
    let res = { err: null, data: null };
    if (contextCustomer && contextUser) {
        const sysManRes = await GatewayDAO.deleteGateway({ contextCustomer, contextUser, gateway });
        const { err, data } = sysManRes;
        if (err) {
            userFunctions.setUserMessage({
                id: v4(),
                content: `Failed to delete gateway ${gateway.eui ?? gateway.name}.${debug ? ` ${err.message}` : ''}`,
                label: 'Gateway Management API',
                type: 'MessageBar',
                severity: Severity.error,
            });
            res.err = err;
        }
        if (data) {
            userFunctions.removeObjectsFromState([gateway]);
            userFunctions.setUserMessage({
                id: v4(),
                content: `Deleted gateway ${gateway.eui ?? gateway.name}.${debug ? `(${data.sk})` : ''}`,
                label: 'Gateway Management API',
                type: 'MessageBar',
                severity: Severity.success,
            });
            res.data = sysManRes.data ?? null;
        }
    }
    else {
        res.err = new Error(`One of contextCustomer or contextUser not present`);
    }
    return res;
};
